import errorHandler from './utils/errorHandler';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  console.log('ProtectedRoute check:', {
    isAuthenticated,
    user,
    allowedRoles,
    currentPath: location.pathname
  });

  if (!isAuthenticated || !user) {
    errorHandler.logDebug('ProtectedRoute', 'Not authenticated, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    errorHandler.logDebug('ProtectedRoute', 'User not authorized for this route');
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;